import { AxiosInstance } from 'axios';
import { BlogTag } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'blog-tag';

export class BlogTagApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getBlogTags(filter?: string): Promise<Array<BlogTag>> {
    await simulate();
    const params = new URLSearchParams();

    if (filter) {
      params.append('filter', filter);
    }

    const queryString = params.toString();
    const url = queryString ? `/?${queryString}` : '/';
    const response = await this.apiInstance.get(url);

    return response.data;
  }
}
